import React from 'react';
import { Flex, Row, message, Divider, Button } from 'antd';
import NavItem from '../../components/nav-item';
import { FileOutlined } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';
import PageList from './page-list';


const iconStyle = {
    fontSize: 28,
}

export default () => {

    return (
        <div>
            {/* <SwitchShop /> */}
            {window.__baseInfo.versionId !== 1 && <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/mall/page/create" text="创建页面">
                    <FileOutlined style={iconStyle} />
                </NavItem>
            </Row>}
            <h2>商城页面</h2>
            <PageList />
        </div>
    );
};